import React from "react";
import { Section, SectionHeading } from "../Section";
import { pathwaySteps } from "../../data/landing";
export function PathwaySection() {
  return <Section tone="cream" cta="I want to use the 15-minute pathway™" data-id="element-222" data-mp="2qtldb93cmrr7">
      <SectionHeading eyebrow="The 7-step case pathway" title={<>
            A repeatable educational pathway, <em className="text-rose" data-id="element-224" data-mp="2gve276vqr3x4">one step at a time</em>
          </>} data-id="element-223" data-mp="2lxd5yhve82ul" />

      <ol className="mx-auto mt-12 max-w-3xl" data-id="element-225" data-mp="3ekhaklqkqf5u">
        {pathwaySteps.map((step, i) => <li key={step.name} className="relative flex gap-4 pb-8 last:pb-0 md:gap-6" data-id="element-226" data-mp="39mxo4yjq2w2t" data-mpi={i}>
            {i < pathwaySteps.length - 1 && <span className="absolute left-[23px] top-12 h-[calc(100%-48px)] w-0.5 bg-line md:left-[27px]" aria-hidden="true" data-id="element-227" data-mp="2zo02q4hlfio1" />}
            <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink font-serif text-xl font-bold text-white md:h-14 md:w-14 md:text-2xl" data-id="element-228" data-mp="1t8pdo2c88d7j">
              {i + 1}
            </span>
            <div className="flex-1 rounded-2xl bg-white p-5 shadow-[0_1px_2px_rgba(23,33,63,0.06)] md:p-6" data-id="element-229" data-mp="3iwx07oh4ds71">
              <h3 className="font-serif text-2xl font-bold uppercase tracking-wide text-ink" data-id="element-230" data-mp="3nt5g54355pf9">{step.name}</h3>
              <ul className="mt-3 space-y-1.5" data-id="element-231" data-mp="390buf0xa0d25">
                {step.questions.map(q => <li key={q} className="flex gap-2 text-[16px] leading-snug text-inkSoft" data-id="element-232" data-mp="3dyvgr2fs7qv1">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-rose" aria-hidden="true" data-id="element-233" data-mp="303kq618klrwh" />
                    {q}
                  </li>)}
              </ul>
            </div>
          </li>)}
      </ol>

      <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-2xl font-bold italic text-ink md:text-3xl" data-id="element-234" data-mp="2v5ri12npintk">
        One case. One pathway. Approximately 15 minutes.
      </p>
    </Section>;
}